import { ConsolidatedMiuConsumption } from '../../models/billing/miuConsumption/ConsolidatedMiuConsumption';
import { BlipApi } from '../BlipApi';
import { METHOD, RequestStatus } from 'shared/Requests';
import { BillingMetrics } from 'shared/BillingMetrics';
import { MonthlyMiuConsumption } from 'models/billing/miuConsumption/MonthlyMiuConsumption';
import { DailyMiuConsumption } from 'models/billing/miuConsumption/DailyMiuConsumption';
import { useSubscriptionReferenceDate } from './BillingApi';

export default class BillingMiuConsumptionApi {
  private readonly BILLING_COMMAND_DESTINATION = 'postmaster@billing.blip.ai';
  private code = '';
  private status = '';
  private useSubscriptionReferenceDate: boolean | undefined = undefined;

  public async getUseSubscriptionReferenceDate(): Promise<void> {
    if (this.useSubscriptionReferenceDate === undefined) {
      this.useSubscriptionReferenceDate = await useSubscriptionReferenceDate();
    }    
  }

  public getStatus() {
    return this.status;
  }

  public getCode() {
    return this.code;
  }

  public setSuccess() {
    this.status = RequestStatus.SUCCESS;
  }

  public setErrorLog(e) {
    const error = JSON.parse(<string>e);
    const {
      status,
      reason: { code },
    } = JSON.parse(error.message);
    this.code = code;
    this.status = status;
    console.log(e);
  }

  public async getConsolidatedMiuConsumption(
    tenantId: string,
    metricIds: string,
    month: string,
    storageType = 1,
  ): Promise<Array<ConsolidatedMiuConsumption>> {
    await this.getUseSubscriptionReferenceDate();
    const uri =
      `/tenants/${tenantId}/monthly-message-metrics/summary?month=${month}` +
      `&metricIdList=${metricIds}` +
      `&useSubscriptionReferenceDate=${this.useSubscriptionReferenceDate}` +
      `&storageType=${storageType}`;

    const command = {
      to: this.BILLING_COMMAND_DESTINATION,
      method: METHOD.GET,
      uri: uri,
    };

    try {
      const {
        response: { items },
      } = await BlipApi.sendCommand(command);
      this.setSuccess();
      return items.map((item) => new ConsolidatedMiuConsumption(item, item.metric.metricId));
    } catch (e) {
      this.setErrorLog(e);
      return new Array<ConsolidatedMiuConsumption>(
        new ConsolidatedMiuConsumption(null, BillingMetrics.monthlyActiveUser),
        new ConsolidatedMiuConsumption(null, BillingMetrics.exchangedMessage),
      );
    }
  }

  public async getMonthlyMiuConsumption(
    tenantId: string,
    metricIds: string,
    month: string,
    registersToTake: number,
    storageType = 1,
  ): Promise<MonthlyMiuConsumption[]> {
    await this.getUseSubscriptionReferenceDate();
    let uri =
      `/tenants/${tenantId}/monthly-message-metrics/monthly/by-bot?month=${month}` +
      `&metricIdList=${metricIds}` +
      `&useSubscriptionReferenceDate=${this.useSubscriptionReferenceDate}`+
      `&storageType=${storageType}`;

    uri = uri + `&$take=${registersToTake}`;

    const command = {
      to: this.BILLING_COMMAND_DESTINATION,
      method: METHOD.GET,
      uri: uri,
    };

    try {
      const {
        response: { items },
      } = await BlipApi.sendCommand(command);
      this.setSuccess();
      return items.map((item) => new MonthlyMiuConsumption(item));
    } catch (e) {
      this.setErrorLog(e);
      return new Array<MonthlyMiuConsumption>();
    }
  }

  public async getDailyMiuConsumption(
    tenantId: string,
    metricIds: string,
    month: string,
    registersToTake: number,
    storageType = 1,
  ): Promise<DailyMiuConsumption[]> {
    await this.getUseSubscriptionReferenceDate();
    let uri =
      `/tenants/${tenantId}/monthly-message-metrics/daily?month=${month}` +
      `&metricIdList=${metricIds}` +
      `&useSubscriptionReferenceDate=${this.useSubscriptionReferenceDate}` +
      `&storageType=${storageType}`;

    uri = uri + `&$take=${registersToTake}`;

    const command = {
      to: this.BILLING_COMMAND_DESTINATION,
      method: METHOD.GET,
      uri: uri,
    };

    try {
      const {
        response: { items },
      } = await BlipApi.sendCommand(command);
      this.setSuccess();
      return items.map((item) => new DailyMiuConsumption(item));
    } catch (e) {
      this.setErrorLog(e);
      return new Array<DailyMiuConsumption>();
    }
  }
}
